
// form input type file
const fileInputs = document.querySelectorAll('input[type="file"]');
fileInputs.forEach((fileInput) => {
  fileInput.addEventListener('change', (e) => {
    const target = e.target as HTMLInputElement;
    const fileName = target.value.split('\\').pop();
    const label = target.nextElementSibling as HTMLSpanElement;
    const span = label.firstElementChild as HTMLSpanElement;
    span.innerText = fileName as string;
  });
});



const formReset = document.querySelector('.form-reset') as HTMLFormElement | null;
formReset?.addEventListener('click', (e) => {
  e.preventDefault();

  // Get the form element
  const form = document.querySelector('.form') as HTMLFormElement;

  // Reset form fields
  form.reset();

  // Reset file input labels
  const fileInputs = document.querySelectorAll('input[type="file"]');
  fileInputs.forEach((fileInput) => {
    const preview = fileInput.previousElementSibling as HTMLDivElement;
    const label = fileInput.nextElementSibling as HTMLLabelElement;
    const span = label.firstElementChild as HTMLSpanElement;
    span.innerText = '';
    preview.innerText = '';
  });

  // Reset CSRF token
  const csrfTokenInput = document.querySelector('input[name="_token"]') as HTMLInputElement;
  if (csrfTokenInput) {
    csrfTokenInput.value = ''; // Set the CSRF token value to an empty string
  }

  // Reset form validation state
  form.classList.remove('was-validated');
});

const configuratorForm = document.querySelector('.form-horizontal') as HTMLFormElement | null;
if (configuratorForm) {
  const resetBtn = document.querySelector('.back') as HTMLButtonElement;
  resetBtn.addEventListener('click', (e) => {
    e.preventDefault();
    configuratorForm.reset();
  });
}
